import { initializeApp, FirebaseOptions } from 'firebase/app';
import {
  getRemoteConfig,
  fetchAndActivate,
  RemoteConfig,
} from 'firebase/remote-config';

type RemoteConfigParams = Record<string, unknown>;

// The Firebase SDK keeps the active config in a private `_storageCache` field —
// not part of the public type. Narrow cast just for that read.
type RemoteConfigWithStorage = RemoteConfig & {
  _storageCache?: {
    activeConfig?: RemoteConfigParams;
  };
};

export default function firebaseConfig(): void {
  const config: FirebaseOptions = {
    apiKey: 'AIzaSyDjsHJNUxIFPplOKWdvVT60sZwBBZmIiko',
    authDomain: 'ed-web-75421.firebaseapp.com',
    projectId: 'ed-web-75421',
    storageBucket: 'ed-web-75421.appspot.com',
    messagingSenderId: '205937023718',
    appId: '1:205937023718:web:c2cd8f62e4e2620e86b927',
  };

  const app = initializeApp(config);
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 15000;

  remoteConfig.defaultConfig = {
    subscrUK: 'subscrUK_a',
    subscrEU: 'subscrEU_a',
    pdf_upsale: 'upsale_on',
    customV2_pdf_19_29: 'customV2_pdf_19_29_a',
    currencyInISO: 'currencyInISO_a',
    ppPDFV2: 'ppPDFV2_a',
    p13_paywall_2blocks: false,
    p13_highPrices: false,
    p13v1_paywall_beforeAfter: false,
    p13v1_emailScreen: false,
    p13v33_emailScreen: false,
    p10_subscrUS: false,
    p13_newPrices_p17_p18: false,
    p13_US_newPrices_p17_p18: false,
    p13v1_paywall_moneyBack: false,
    p13_mix_paywall_discountPercent: false,
    receive_email: 'false',
    p20v53_paywall_lastDogTraining: 'false',
    p20v54_paywall_lastDogTraining: 'false',
    hardware: 'false',
    p20v1_paywall_redLabelDiscount_noSpecial: 'false',
    p20v54_discountScreen_fortune: 'false',
    p20v1_paywall_2paymentBlocks: 'false',
    v1p20_PDF_paywall: 'false',
    p20v1_paywall_2paymentBlocks_non_US: 'false',
    supplements: 'false',
    p20v1_discountScreen_scratch: 'false',
    p20v1_emailScreenFlow: 'false',
  };

  function checkRemoteConfigValue(params: RemoteConfigParams): void {
    window.firebaseConfigData = params;
    console.log(window.firebaseConfigData);
  }

  fetchAndActivate(remoteConfig)
    .then(() => {
      /* eslint no-underscore-dangle: ['error', { 'allow': ['_storageCache'] }] */
      const cached = (remoteConfig as RemoteConfigWithStorage)._storageCache?.activeConfig;
      if (cached) {
        checkRemoteConfigValue(cached);
      } else {
        checkRemoteConfigValue(remoteConfig.defaultConfig as RemoteConfigParams);
      }
    })
    .catch((err) => {
      console.log(err);
      checkRemoteConfigValue(remoteConfig.defaultConfig as RemoteConfigParams);
    });

  console.log('firebaseConfig enabled');
}
